import { doGet } from 'services/common'

const getSpinResults = () => {
  return doGet('/spin')
}

const getTotalSpinsToday = () => {
  return doGet('/spin/details')
}

const getLastSpinWinner = () => {
  return doGet('/spin/lastBigWinner')
}

const getDataForSpinModal = () => {
  return Promise.all([getTotalSpinsToday(), getLastSpinWinner()]).then(
    results => {
      return {
        totalSpinsToday: results[0].detail.totalSpinsToday,
        spinsRemaining: results[0].detail.spinsRemaining,
        lastWinner: results[1].detail.winnerName,
        lastWinDate: results[1].detail.winDateTime,
      }
    },
  )
}

export { getDataForSpinModal, getSpinResults }
